import type { ChatSituationId } from "./learning-chat-situations.js";

export const defaultContextOptionIds = ["1", "2", "3", "4", "5"] as const;
export const defaultGoalOptionIds = ["clarity", "agreement", "unknown"] as const;
export const situationContextOptionIds = ["1", "2", "3", "4"] as const;
export const situationGoalOptionIds = ["1", "2", "3"] as const;

export function clarifyQuestionKey(situationId: ChatSituationId | undefined, step: 0 | 1): string {
  if (!situationId) {
    return step === 0
      ? "learningRoute.chatClarify.partners.question"
      : "learningRoute.chatClarify.goal.question";
  }
  return step === 0
    ? `learningRoute.situations.${situationId}.clarify.context.question`
    : `learningRoute.situations.${situationId}.clarify.goal.question`;
}

export function clarifyOptionKey(
  situationId: ChatSituationId | undefined,
  step: 0 | 1,
  optionId: string,
): string {
  if (!situationId) {
    return step === 0
      ? `learningRoute.chatClarify.partners.options.${optionId}`
      : `learningRoute.chatClarify.goal.options.${optionId}`;
  }
  return step === 0
    ? `learningRoute.situations.${situationId}.clarify.context.options.${optionId}`
    : `learningRoute.situations.${situationId}.clarify.goal.options.${optionId}`;
}

export function clarifyOptionIdsFor(
  situationId: ChatSituationId | undefined,
  step: 0 | 1,
): readonly string[] {
  if (!situationId) {
    return step === 0 ? defaultContextOptionIds : defaultGoalOptionIds;
  }
  return step === 0 ? situationContextOptionIds : situationGoalOptionIds;
}

export function resultIntroKey(situationId: ChatSituationId | undefined): string {
  if (!situationId) return "learningRoute.chatResult.intro";
  return `learningRoute.situations.${situationId}.resultIntro`;
}
